export const BUILD = {
  number: '2.9.0',
  published: '31 July 2026',
};

export const BUILD_HISTORY = [
  {
    build: '2.9.0', date: '31 July 2026',
    changes: [
      'Section C KPI fields now accept 0 as a valid value (data breaches, attrition, training hours, renewable %, e-waste %, local hiring %, community spend, AI %, living wage %) — zeros display, save and count in analytics',
      'Admin Console loads faster: member list API batched (no more per-member queries)',
      'Admin link removed from the public home page (direct /admin-login URL still works)',
      'Launch Readiness Check: one-click pre-launch checklist in the Danger Zone confirming default password changed and all test data purged',
    ],
  },
  {
    build: '2.8.0', date: '30 July 2026',
    changes: [
      'Security hardening: admin password change (Console header), env-driven admin seeding, login rate limiting with 15-minute lockout',
      'Excel/CSV exports sanitized against spreadsheet formula injection',
      'Generic error messages; AI Advisor sessions locked to their owner',
      'Admin Activity Log: member changes, code regenerations, flag changes, purges and password changes fully recorded — filterable by action/date with CSV export',
    ],
  },
  {
    build: '2.7.0', date: '27 July 2026',
    changes: [
      'Audit protection: members with a completed response can no longer be deleted; all deletions are audit-logged',
      'CSV upload accepts company-name-only rows (email optional) and skips header rows',
      'Segment distribution percentages now always sum to 100%',
      'Admin Danger Zone: purge all member & response data for clean testing rounds',
      'Deletion Audit viewer in the Admin Console — see who removed which member and when',
    ],
  },
  {
    build: '2.6.0', date: '22 July 2026',
    changes: [
      'Pre-submission Consistency Check — flags blank answers and rating inconsistencies before submit',
      'Respondent and Admin User Guides with build tracking',
    ],
  },
  {
    build: '2.5.0', date: '22 July 2026',
    changes: [
      'QA fixes: even materiality-matrix axis ticks, clearer selected rating states, distinct placeholder vs entered-value styling',
      'Test-member flag with exclusion from all statistics + "Hide test members" table filter',
      'Connected survey logic: Scope 2 emissions auto-estimate from electricity, Section D risk hints from Section B ratings, 0–100 caps on percentage fields',
    ],
  },
  {
    build: '2.4.0', date: '22 July 2026',
    changes: [
      'Add member with company name only — Company & Invite Codes auto-generate',
      'Sign-in inputs auto-clean pasted codes (spaces, dashes, lowercase)',
      'New A2 business segment options incl. Support Services sub-group + dashboard drill-down',
      'IBPAP & SusTek co-branding on all page footers and PDF exports',
    ],
  },
  {
    build: '2.3.0', date: '18 July 2026',
    changes: [
      'Compliance Acceptance Gate (Privacy Notice + Member Acceptance Policy) with audit timestamps',
      'Downloadable signed member report (compliance certificate + response + benchmark PDF)',
      'Graceful session-expiry handling with automatic redirect to sign-in',
    ],
  },
  {
    build: '2.2.0', date: '17 July 2026',
    changes: [
      'Public "State of IT-BPM ESG" teaser page with social share cards',
      'Usage & Performance Telemetry module and AI Transparency page',
    ],
  },
  {
    build: '2.1.0', date: '16 July 2026',
    changes: [
      'Bulk exports (Excel workbook + PDF summary report)',
      'Automated reminder tracker with copy-ready nudges for invited and stalled members',
      'Participation Momentum chart',
    ],
  },
  {
    build: '2.0.0', date: '15 July 2026',
    changes: [
      'Rebrand to Benchmark PH',
      'Invite-only member access via Company Code + Invite Code',
      'Admin Console for participating-member management',
    ],
  },
  {
    build: '1.0.0', date: '25 March 2026',
    changes: [
      'Initial launch: ESG Double Materiality questionnaire (Sections A–D), AI Advisor, analytics dashboard',
    ],
  },
];
